import { Builder, IWith } from '../utils';

class CommentDataBuilder extends Builder<Presentation.Data.Comment, {}> {}

export class CommentBuilder {
  public static new(): IWith<Presentation.Data.Comment, { id: string }> {
    return new CommentDataBuilder({}).with('id', 'xxx');
  }
}
